import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import {
  CommonUiModule,
  UtilsModule,
  PipesModule,
  SortableColumnModule,
} from '@tablesready/common-ui';
import { HistoryComponent } from './history.component';
import { HistoryRoutingModule } from './history.routing.module';
import { BadgeModule } from '@tablesready/frontend-badge';
import { IonicModule } from '@ionic/angular';
import { FrontendHeaderModule } from '@tablesready/frontend-header';
import { LocationSwitcherModule } from '@tablesready/frontend-location-switcher';
import { StatusModule } from '@tablesready/frontend-status-bar';
import { AlertsModule, ClockModule } from '@tablesready/frontend-alerts-bar';
import { AppVariablesModule } from '@tablesready/frontend-variables';
import { FrontendPullRefreshModule } from '@tablesready/frontend-pull-refresh';

@NgModule({
  declarations: [
    HistoryComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    CommonUiModule,
    PipesModule,
    AlertsModule,
    ClockModule,
    AppVariablesModule,
    StatusModule,
    UtilsModule,
    NgbModule,
    InfiniteScrollModule,
    HistoryRoutingModule,
    LocationSwitcherModule,
    SortableColumnModule,
    BadgeModule,
    IonicModule,
    FrontendHeaderModule,
    FrontendPullRefreshModule,
  ],
})
export class HistoryModule { }
